import React from "react";
import SubHeader from "../customComponents/SubHeader";
import LoyaltyPointsForm from "./LoyaltyPointsForm";

const LoyaltyPoints = ({toggleMobileMenu}) => {
  return (
    <>
      <SubHeader text={"Edit customer balance"} toggleMobileMenu={toggleMobileMenu}/>
      <div className="w-full mb-10 md:mb-0 px-4 md:px-6 lg:px-0 mx-auto max-w-[1100px]">
        <div className="w-full mx-auto rounded-[10px] mt-6 lg:mt-16 shadow-custom-dark">
          <div className="w-full flex flex-col lg:flex-row min-h-[400px] lg:h-[500px]">
            <div className=" lg:flex lg:w-[35%] items-center bg-white rounded-t-[10px] lg:rounded-l-[10px] lg:rounded-tr-none">
              <img
                className="w-full mx-auto rounded-t-[10px] lg:rounded-l-[10px] lg:rounded-tr-none"
                src="/forms/formbg.jpg"
                alt=""
              />
            </div>
            <div className="w-full lg:w-[65%] py-6 px-4 lg:px-6 rounded-[10px] lg:rounded-l-none">
              <LoyaltyPointsForm 
                header={'Modify loyalty points'}
                searchLabel={'Search customer Mob no'}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoyaltyPoints;